import { Component }        from '@angular/core';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Title }            from '@angular/platform-browser';
import { VERSION }          from '@environments/version';
import { environment }      from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SwUpdate }         from '@angular/service-worker';
import { Router }           from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [NgbTooltipConfig]
})
export class AppComponent {
  constructor(
    config: NgbTooltipConfig,
    title: Title,
    public translate: TranslateService,
    private swUpdate: SwUpdate,
    private router: Router) {


    config.placement = 'top';
    config.container = 'body';
    config.triggers = 'hover';
    config.tooltipClass = 'tooltip';
    title.setTitle(`Imagesound - ${environment.application} v${VERSION.number.toString()}`);
    translate.addLangs(['en-US', 'en-GB', 'fr', 'es', 'de', 'zh-CHS']);

    let browserLang = translate.getBrowserLang();
    if (browserLang === 'en')
      browserLang = translate.getBrowserCultureLang();

    this.useLanguage(browserLang.match(/en-GB|fr|es|de|zh-CHS/) ? browserLang : 'en-GB');
  }
  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm("A new version of the Operations Portal is available. Would you like to load the new version?")) {
          window.location.reload();
        }
      });
    }
  }
  public useLanguage(language: string): void {
    this.translate.use(language);
  }
}
